// A record's sede reaches the frontend as the provider's raw hyperlink
// (`https://<instance>.provet.cloud/api/0.1/department/2/`), never as a bare id: `ClientDto`'s and
// `PatientDto`'s `HomeDepartmentUrl` are passed through untouched. The trailing segment is the
// provider's own department id, which matches `ClinicDepartment.externalId` -- NOT the local
// `ClinicDepartment.id`.
export function extractDepartmentId(hyperlink: string | null | undefined): string | null {
  if (!hyperlink) return null;

  const withoutQuery = hyperlink.split(/[?#]/)[0];
  const lastSegment = withoutQuery.split('/').filter((segment) => segment.length > 0).pop();

  return lastSegment ?? null;
}
